import AbandonedCart from "@/assets/icons/AbandonedCart";
import Analytics from "@/assets/icons/Analytics";
import CalcReport from "@/assets/icons/CalcReport";
import LinkReport from "@/assets/icons/LinkReport";
import ProfitsByAffiliate from "@/assets/icons/ProfitsByAffiliate";
import ProfitsByAffiliates from "@/assets/icons/ProfitsByAffiliates";
import RecoverSales from "@/assets/icons/RecoverSales";
import { usePermissions } from "@/auth/PermissionsContext";
import { Badge } from "@/components/ui/badge";
import { Card } from "@/components/ui/card";
import LayoutInside from "@/layout/LayoutInside";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

export default function Reports() {
  const { t } = useTranslation(["reports", "common", "financialAudit"]);
  const navigate = useNavigate();
  const breadcrumbItems = [{ text: t("common:reports"), link: "/reports" }];

  const { hasPermission } = usePermissions();

  const allReports = [
    {
      label: t("reports:cart_abandonment.title"),
      icon: <AbandonedCart />,
      comingSoon: false,
      id: "cart-abandonment",
      permission: 'reports.view_cart_abandonment',
    },
    {
      label: t("common:sales_by_status"),
      icon: <ProfitsByAffiliates />,
      comingSoon: false,
      id: "status_sale",
      permission: 'reports.view_financial_analysis',
    },
    {
      label: t("financialAudit:title"),
      icon: <CalcReport />,
      comingSoon: false,
      id: "financial-audit",
      permission: 'reports.view_financial_analysis',
    },
    {
      label: t("reports:utmPanel.title"),
      icon: <LinkReport />,
      comingSoon: false,
      id: "utm-panel",
      permission: 'reports.view_utm_panel',
    },
    {
      label: t("reports:analytics"),
      icon: <Analytics />,
      comingSoon: false,
      id: "analytics",
      permission: 'reports.view_analytics',
    },
    {
      label: t("reports:partner_commissions"),
      icon: <ProfitsByAffiliate />,
      comingSoon: false,
      id: "partner-commissions",
      permission: 'partner_indications.view_partner_commissions',
    },
    {
      label: t("reports:profit_per_affiliate"),
      icon: <ProfitsByAffiliate />,
      comingSoon: false,
      id: "profit_per_affiliate",
      permission: 'reports.view_financial_analysis',
    },
    {
      label: t("reports:sales_recovery"),
      icon: <RecoverSales />,
      comingSoon: true,
      id: "sales_recovery",
      permission: null,
    },
  ];

  const reports = allReports.filter(
    (r) => r.comingSoon || !r.permission || hasPermission(r.permission)
  );

  return (
    <LayoutInside hasBgBlur items={breadcrumbItems}>
      <div className="mb-6">
        <h1 className="text-xl font-semibold">{t("reports:select_report")}</h1>
        <p className="text-muted-foreground text-sm mt-1">
          {t("reports:report_description")}
        </p>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
        {reports.map((report) => (
          <Card
            key={report.id}
            className={`group relative p-4 pt-2 space-y-3 cursor-pointer transition-all duration-300 !bg-[#18181B] overflow-hidden rounded-xl border ${report.comingSoon
              ? "cursor-not-allowed opacity-40"
              : "cursor-pointer"
              }
           `}
            onClick={() => {
              if (!report.comingSoon) {
                navigate(`/reports/${report.id}`);
              }
            }}
          >
            <div
              className="absolute inset-0 rounded-xl opacity-0 group-hover:opacity-100 transition-opacity duration-300"
              style={{
                background:
                  "linear-gradient(to right, #1F1F23 70%, #404a9399 100%)",
              }}
            ></div>

            <div className="relative z-10 flex items-center justify-between">
              {report.icon}
              {report.comingSoon && (
                <Badge variant="secondary" className="text-xs px-2 py-0.5">
                  {t("common:coming_soon")}
                </Badge>
              )}
            </div>
            <h3 className="relative z-10 text-sm font-medium">
              {report.label}
            </h3>
          </Card>
        ))}
      </div>
    </LayoutInside>
  );
}
